export class TaskMutex {
  isRunning = false;

  async executeIfNotRunning<T>(task: () => Promise<T> | T) {
    if (!this.isRunning)
      try { this.isRunning = true; return await task(); }
      finally { this.isRunning = false; }
  }
}

export class TaskCounter {
  runningCount = 0;

  async execute<T>(task: () => Promise<T>) {
    try { this.runningCount++; return await task(); }
    finally { this.runningCount--; }
  }
}
